// extracted by mini-css-extract-plugin
module.exports = {"loadingBox":"VehicleState_loadingBox__2wWos","validating":"VehicleState_validating__2lLkt"};